// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-content[data-v-ba89f5fe]{max-width:900px}ul[data-v-ba89f5fe]{padding-left:20px}", ""]);
// Exports
module.exports = exports;
